import { Suspense } from 'react';
import { ArtistBankAccounts, ArtistContractingParty } from '@features';
import { Grid, Skeleton, Stack } from '@mantine/core';

const COL_SPAN = { base: 12, md: 6 };
const SKELETON_MIN_HEIGHT = 100;

export const ArtistDetailsFinancePage: React.FC = () => {
  return (
    <Stack py="md">
      <Grid>
        <Grid.Col span={COL_SPAN}>
          <Suspense fallback={<Skeleton mih={SKELETON_MIN_HEIGHT} />}>
            <ArtistBankAccounts />
          </Suspense>
        </Grid.Col>
        <Grid.Col span={COL_SPAN}>
          <Suspense fallback={<Skeleton mih={SKELETON_MIN_HEIGHT} />}>
            <ArtistContractingParty />
          </Suspense>
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
